import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromEmployeeMainReducer from '../employee-detail.reducer';
import { CurrentBankProofState, bankProofFeatureKey } from '../reducers/bank-proof.reducer';
import * as bankProofReducer from '../reducers/bank-proof.reducer';
import * as employeeDetailsReducer from '../employee-detail.reducer';
import * as archivedProofOfGovIdReducer from '../reducers/archived-proof-gov-id.reducer';

export const getCurrentBankProofs = createSelector(employeeDetailsReducer.getBankProofsState, bankProofReducer.getCurrentBankProofResponse);

// //#region Employee detail ROOT STATE
//   BankProofState
// >(fromEmployeeMainReducer.employeeDetailFeatureKey);
// //#endregion

// //#region Employee govId  proof SUB STATE
//   getMainEmployeeState,
// //#endregion

